export const translationsByCollectionNameByTranslationItemsSearch = `
  query translationsByCollectionNameByTranslationSearch(
    $collectionName: String!
    $translationSearch: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTranslationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    translationsByCollectionNameByTranslationSearch(
      collectionName: $collectionName
      translationSearch: $translationSearch
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        item {
          number
          translations {
            items {
              collectionName
              field
              id
              languageCode
              objectID
              translation
              translationSearch
            }
          }
          title
          id
          coverImageId
          itemsHeadID
          variant {
            optionName
            optionValues
          }
        }
        productRequest {
          id
          positionNumber
        }
        createdAt
        languageCode
        field
        translation
        translationSearch
        collectionName
        objectID
        updatedAt
      }
      nextToken
    }
  }
`;

export const itemsByNumber = /* GraphQL */ `
  query ItemsByNumber(
    $baseType: String!
    $number: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    itemsByNumber(
      baseType: $baseType
      number: $number
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        number
        translations {
          items {
            collectionName
            field
            id
            languageCode
            objectID
            translation
            translationSearch
          }
        }
        title
        id
        coverImageId
        itemsHeadID
        variant {
          optionName
          optionValues
        }
      }
    }
  }
`;

export const companiesByTypeByCompanyNameSearch = /* GraphQL */ `
  query CompaniesByTypeByCompanyName(
    $type: String!
    $nameSearch: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompaniesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesByTypeByCompanyNameSearch(
      type: $type
      nameSearch: $nameSearch
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        number
        name
        nameSearch
        type
      }
      nextToken
    }
  }
`;

export const companiesByCompanyNumber = /* GraphQL */ `
  query CompaniesByCompanyNumber(
    $baseType: String!
    $number: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompaniesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesByCompanyNumber(
      baseType: $baseType
      number: $number
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        number
        name
        baseType
        type
      }
      nextToken
    }
  }
`;

export const searchBarGetOrdersByOrderNumber = `
query MyQuery($orderNumber: ModelStringKeyConditionInput!) {
  ordersByOrderNumber(baseType: "Order", orderNumber: $orderNumber)
   {
    items
     {
      id
      orderNumber
      customerReference
    }
  }
}`;

export const searchBarGetOrdersByCustomerReference = `query MyQuery($customerReference: ModelStringKeyConditionInput!) {
  ordersByCustomerReference(baseType: "Order", customerReference: $customerReference) {
    items {
      id
      orderNumber
      customerReference
    }
  }
}`;

export const searchBarGetPurchaseOrdersByPurchaseOrderNumber = `query MyQuery($purchaseOrderNumber: ModelStringKeyConditionInput!) {
  purchaseOrdersByPurchaseOrderNumber(baseType: "PurchaseOrder", purchaseOrderNumber: $purchaseOrderNumber) {
    items {
      id
      purchaseOrderNumber
      sapReference
    }
  }
}`;
export const searchBarGetPurchaseOrdersBySapReference = `query MyQuery($sapReference: ModelStringKeyConditionInput!) {
  purchaseOrdersBySapReference(baseType: "PurchaseOrder", sapReference: $sapReference) {
    items {
      id
      purchaseOrderNumber
      sapReference
    }
  }
}`;

export const searchBarGetShipmentsByPositionNumber = `query MyQuery($positionNumber: ModelStringKeyConditionInput!) {
  shipmentsByPositionNumber(baseType: "SeaFreight", positionNumber: $positionNumber) {
    items {
      id
      positionNumber
      trackingCode
    }
  }
}`;

export const shipmentsByTrackingCode = /* GraphQL */ `
  query ShipmentsByTrackingCode(
    $baseType: String!
    $trackingCode: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipmentsByTrackingCode(
      baseType: $baseType
      trackingCode: $trackingCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        positionNumber
        trackingCode
      }
    }
  }
`;

export const searchBarGetCustomsByPositionNumber = `query MyQuery($number: ModelStringKeyConditionInput!) {
  customsByPositionNumber(baseType: "Customs", positionNumber: $number) {
    items {
      mrnNumber
      positionNumber
      id
    }
  }
}`;

export const searchBarGetShipmentsByPositionNumberAirfreight = `query MyQuery($positionNumber: ModelStringKeyConditionInput!) {
  shipmentsByPositionNumber(baseType: "AirFreight", positionNumber: $positionNumber) {
    items {
      id
      positionNumber
      trackingCode
    }
  }
}`;

export const searchBarGetDeliveriesByPositionNumber = `query MyQuery($positionNumber: ModelStringKeyConditionInput!) {
  deliveriesByPositionNumber(baseType: "Delivery", positionNumber: $positionNumber) {
    items {
      id
      positionNumber
      type
    }
  }
}`;

export const searchBarGetProductRequestByPositionNumber = `query MyQuery($positionNumber: ModelStringKeyConditionInput!) {
  productRequestsByPositionNumber(baseType: "ProductRequest", positionNumber: $positionNumber) {
    items {
      id
      positionNumber
      translations {
        items {
          translation
          languageCode
        }
      }
    }
  }
}`;

export const listDocuments = /* GraphQL */ `
  query ListDocuments($filter: ModelDocumentsFilterInput) {
    listDocuments(filter: $filter) {
      items {
        id
        collectionName
        name
        storageUrl
        objectID
      }
    }
  }
`;

export const listCustomerRequestItems = /* GraphQL */ `
  query ListCustomerRequestItems(
    $filter: ModelCustomerRequestItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerRequestItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        companyID
        title
        description
        customerArticleNumber
        itemsID
        customerRequestsID
        quantity {
          value
          unit
        }
      }
    }
  }
`;

export const customerRequestsByNumber = /* GraphQL */ `
  query CustomerRequestsByNumber(
    $baseType: String!
    $number: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerRequestsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerRequestsByNumber(
      baseType: $baseType
      number: $number
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        number
        company {
          name
        }
        reference
        id
      }
    }
  }
`;

export const customerRequestsByReference = /* GraphQL */ `
  query CustomerRequestsByReference(
    $baseType: String!
    $reference: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerRequestsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerRequestsByReference(
      baseType: $baseType
      reference: $reference
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        number
        company {
          name
        }
        reference
        id
      }
    }
  }
`;
export const customerRequestItemsByTitle = /* GraphQL */ `
  query CustomerRequestItemsByTitle(
    $baseType: String!
    $title: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerRequestItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerRequestItemsByTitle(
      baseType: $baseType
      title: $title
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        customerArticleNumber
        title
        customerRequest {
          number
          company {
            name
          }
          reference
          id
        }
      }
    }
  }
`;

export const customerRequestItemsByCustomerArticleNumber = /* GraphQL */ `
  query CustomerRequestItemsByCustomerArticleNumber(
    $baseType: String!
    $customerArticleNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerRequestItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerRequestItemsByCustomerArticleNumber(
      baseType: $baseType
      customerArticleNumber: $customerArticleNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        customerArticleNumber
        title
        customerRequest {
          number
          company {
            name
          }
          reference
          id
        }
      }
    }
  }
`;

export const usersByEmail = /* GraphQL */ `
  query UsersByEmail(
    $email: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUsersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        company {
          id
          number
          name
          baseType
          type
        }
      }
    }
  }
`;
